import { put, takeEvery, select } from 'redux-saga/effects';
import _get from 'lodash/get';

import { trackEvent } from '../utils/utils';
import ActionTypes from '../constants/ActionTypes';
import { progressStart, progressStop } from '../actions';

function* setFingerPrint(args) {
  try {
    yield put(progressStart());
    const { fingerPrint } = args;
    const fpExist = sessionStorage.getItem('ds-fingerprint');
    const fpHash = _get(fingerPrint, 'trigger.fingerprint.id');
    if (!fpExist && fpHash) sessionStorage.setItem('ds-fingerprint', fpHash);
    yield put({
      type: `${ActionTypes.SET_FINGERPRINT}_SUCCESS`,
      fingerPrint,
    });
  } finally {
    yield put(progressStop());
  }
}

function* trackSocketConnectionError() {
  try {
    yield put(progressStart());
    trackEvent('socket-connect-error');
  } finally {
    yield put(progressStop());
  }
}
function* trackSocketError() {
  try {
    yield put(progressStart());
    trackEvent('socket-error');
  } finally {
    yield put(progressStop());
  }
}
function* trackSocketDisconnected() {
  const isTestSubmitInProcess = yield select(
    state => state.test.isTestSubmitInProcess
  );
  try {
    if (!isTestSubmitInProcess) yield put(progressStart());
    trackEvent('socket-disconnected');
  } finally {
    if (!isTestSubmitInProcess) yield put(progressStop());
  }
}
function* trackTestStart(args) {
  try {
    yield put(progressStart());
    trackEvent('started-test', args.meta);
  } finally {
    yield put(progressStop());
  }
}
function* trackFinishTest() {
  const isTestSubmitInProcess = yield select(
    state => state.test.isTestSubmitInProcess
  );
  try {
    if (!isTestSubmitInProcess) yield put(progressStart());
    trackEvent('submitted-all-solutions');
  } finally {
    if (!isTestSubmitInProcess) yield put(progressStop());
  }
}
function* trackSubmitSection() {
  try {
    yield put(progressStart());
    trackEvent('section-submitted-successfully');
  } finally {
    yield put(progressStop());
  }
}

export default function* loadProctorSaga() {
  yield takeEvery(ActionTypes.SET_FINGERPRINT, setFingerPrint);
  yield takeEvery(
    ActionTypes.TRACK_SOCKET_CONNECTION_ERROR,
    trackSocketConnectionError
  );
  yield takeEvery(ActionTypes.TRACK_SOCKET_ERROR, trackSocketError);
  yield takeEvery(
    ActionTypes.TRACK_SOCKET_DISCONNECTED,
    trackSocketDisconnected
  );
  yield takeEvery(ActionTypes.TRACK_TEST_START, trackTestStart);
  yield takeEvery(ActionTypes.TRACK_FINISH_TEST, trackFinishTest);
  yield takeEvery(ActionTypes.TRACK_SUBMIT_SECTION, trackSubmitSection);
}
